var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZai = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  stroke: "#FFF",
  strokeMiterlimit: 10,
  strokeWidth: 0.494,
  d: "M19.428 22.557H4.566a3.125 3.125 0 0 1-3.126-3.125V4.57a3.125 3.125 0 0 1 3.126-3.126h14.87A3.125 3.125 0 0 1 22.56 4.57v14.87a3.135 3.135 0 0 1-3.133 3.117z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m12.364 5.828-1.016 1.445a.86.86 0 0 1-.703.367H5.097V5.82c-.008.008 7.267.008 7.267.008m6.9 0-8.72 12.354H4.73l8.72-12.354zM11.63 18.182l1.023-1.454a.86.86 0 0 1 .703-.367h5.54v1.82z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgZai);
export default ForwardRef;